import request from '@/utils/request'

/**
 * @param {import('@/types/generated/openapi').paths['/notice/get_notice_list']['get']['parameters']['query']} params
 * @returns {Promise<import('@/types/utils').R<import('@/types/generated/openapi').paths['/notice/get_notice_list']['get']['responses']['200']['content']['application/json']>>}
 */
export function getNoticeList(params) {
  return request({
    url: 'notice/get_notice_list',
    method: 'get',
    params
  })
}

/**
 * @param {import('@/types/generated/openapi').paths['/notice/get_site_list']['get']['parameters']['query']} params
 * @returns {Promise<import('@/types/utils').R<import('@/types/generated/openapi').paths['/notice/get_site_list']['get']['responses']['200']['content']['application/json']>>}
 */
export function getSiteList(params) {
  return request({
    url: 'notice/get_site_list',
    method: 'get',
    params
  })
}

/**
 * @param {import('@/types/generated/openapi').paths['/notice/create_notice']['post']['requestBody']['content']['application/json']} data
 * @returns {Promise<import('@/types/utils').R<import('@/types/generated/openapi').paths['/notice/create_notice']['post']['responses']['200']['content']['application/json']>>}
 */
export function createNotice(data) {
  return request({
    url: 'notice/create_notice',
    method: 'post',
    data
  })
}

/**
 * @param {import('@/types/generated/openapi').paths['/notice/update_notice']['post']['requestBody']['content']['application/json']} data
 * @returns {Promise<import('@/types/utils').R<import('@/types/generated/openapi').paths['/notice/update_notice']['post']['responses']['200']['content']['application/json']>>}
 */
export function updateNotice(data) {
  return request({
    url: 'notice/update_notice',
    method: 'post',
    data
  })
}

/**
 * @param {import('@/types/generated/openapi').paths['/notice/delete_notice']['post']['requestBody']['content']['application/json']} data
 * @returns {Promise<import('@/types/utils').R<import('@/types/generated/openapi').paths['/notice/delete_notice']['post']['responses']['200']['content']['application/json']>>}
 */
export function deleteNotice(data) {
  return request({
    url: 'notice/delete_notice',
    method: 'post',
    data
  })
}

// 向后兼容：re-export 已拆分到各域文件的接口，避免破坏现有 import
export * from './channel'
export * from './channel-group'
export * from './template'
export * from './history'
export * from './token'
export * from './group'
export * from './event-log'
export * from './message'
export * from './config'
